import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  controlAreaClass: {
    display: "flex",
    minWidth: 180,
  },
  addButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    width: "100%",
  },
  filters: {
    margin: "0.8rem 0",
    display: "flex",
  },
  branchFilter: {
    width: "50%",
    paddingRight: "0.5rem",
  },
  documentNumbersFilter: {
    width: "50%",
  },
  SelectMessage: {
    marginTop: "10rem",
    marginBottom: "10rem",
  },
  warnningMessage: {
    color: theme.palette.common.white,
    textAlign: 'center',
    marginTop: '0',
    fontSize: '18px',
    fontStyle: 'normal',
    letterSpacing: '-1px',
  }
}));

export default useStyles;
